export default __webpack_public_path__ + "static/media/pluma-desktop.151c93ab.png";